.body {
  box-sizing: border-box;
  display: flex;
  gap: var(--pgm-sys-spacing-6);
  justify-content: center;
  margin: 0 auto;
  max-width: 1600px;
  padding: var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-16);
  width: 100%;
}

.main {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-14, 56px);
  min-width: 0;
}

.about {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
}

.text {
  color: var(--pgm-sys-color-on-surface-variant);
  margin: 0;
}

.image {
  border-radius: 20px;
  height: 236px;
  object-fit: cover;
  width: 100%;
}
